module.exports = __webpack_public_path__ + "media/hyperplastic polyp.9b02623c.wav";